document.addEventListener("DOMContentLoaded",function(){
  var zero=document.getElementById("ComecarUrsinhaDoZero");
  if(!zero)return;

  var botao=document.createElement("button");
  botao.type="button";
  botao.id="VerUrsinhasProntas";
  botao.className="monte-comecar-zero monte-ursinhas-prontas";
  botao.innerHTML='<span class="monte-comecar-zero-icone">🐻✨</span><span>Escolha um modelo pronto</span>';

  zero.parentNode.insertBefore(botao,zero);
});

document.addEventListener("DOMContentLoaded",function(){

  var botao=document.getElementById("VerUrsinhasProntas");
  if(!botao)return;

  var painel=document.createElement("div");
  painel.id="PainelUrsinhasProntas";
  painel.innerHTML=
    '<div class="ursinhas-prontas-overlay"></div>'+
    '<div class="ursinhas-prontas-caixa">'+
      '<button type="button" class="ursinhas-prontas-fechar">×</button>'+
      '<h3>Escolha uma ursinha pronta</h3>'+
      '<p>Escolha um modelo para começar e depois personalize como quiser.</p>'+
      '<div class="ursinhas-prontas-lista">'+
  '<div class="ursinha-pronta-card">'+
    '<img src="https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-b2f11676.png?v=1788217706" alt="Ursinha pronta">'+
    '<h4>Ursinha Inverno</h4>'+
    '<button type="button" class="ursinha-pronta-escolher">Escolher esta ursinha</button>'+
  '</div>'+
'</div>'+
    '</div>';

  document.body.appendChild(painel);

  botao.addEventListener("click",function(){
    painel.classList.add("ativo");
  });

  painel.addEventListener("click",function(e){
    if(
      e.target.classList.contains("ursinhas-prontas-overlay") ||
      e.target.classList.contains("ursinhas-prontas-fechar")
    ){
      painel.classList.remove("ativo");
    }
  });

});

/* =========================================================
   URSINHAS PRONTAS — APLICAR MONTAGEM
   ========================================================= */

/* =========================================================
   URSINHAS PRONTAS — CADASTRO DOS MODELOS
   ========================================================= */

document.addEventListener("DOMContentLoaded", function(){

  var modelosProntos = [
    {
      nome: "Ursinha Maya",
      imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-b2f11676.png?v=1788217706",
      variant: "46984434581588",
      itens: [
        "23cm",
        "bege",
        "Pé para usar com sapato",
        "castanho",
        "Calçola de poá - Branca",
        "Shorts c/ cinto branco - Marrom",
        "Camisa com gola - Branca",
        "Casaco com gola - Marrom",
        "Meia com flor - Branca",
        "Coturno - Bege",
        "Touca com protetor de orelha - Bege",
        "Bolsa crossbody - Dourada",
        "Óculos de grau",
        "Sem gravação"
            ]
    },
    {
  nome: "Ursinha Olívia",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-2f947863.png?v=1788392669",
  variant: "46984434155604",
  itens: [
    "23cm",
    "marrom",
    "Pé para usar com sapato",
    "verde",
    "Focinho - Preto",
    "Calçola de poá - Branca",
    "Shorts c/ cinto preto - Verde musgo",
    "Camisa manga curta bufante - Verde militar",
    "Meia com flor - Branca",
    "Tênis - Preto",
    "Bolsa transversal - Preta",
    "Óculos de grau",
    "Relógio - Verde"
  ]
},
{
  nome: "Ursinha Pérola",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-b76c421.png?v=1788554403",
  variant: "46984433893460",
  itens: [
    "23cm",
    "marfim",
    "Pé para usar com sapato",
    "azul",
    "Focinho - Marrom",
    "Calçola de poá - Branca",
    "Shorts c/ cinto branco - Marfim",
    "Camisa manga curta bufante - Branca",
    "Casaco com gola - Marfim",
    "Meia com flor - Branca",
    "Sandália - Branca",
    "Tiara - Branca"
  ]
},
    {
      nome: "Ursinha Chloe",
      imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-727a58c0_1.png?v=1788243672",
      variant: "46984434417748",
      itens: [
        "23cm",
        "marfim",
        "Pé para usar com sapato",
        "verde",
        "Focinho - Preto",
        "Calçola de poá - Branca",
        "Shorts c/ cinto preto - Verde musgo",
        "Camisa manga curta bufante - Branca",
        "Meia com flor - Branca",
        "Sandália - Preta",
        "Boina - Branca",
        "Bolsa crossbody - Preta",
        "Óculos de grau",
        "Relógio - Verde"
  ]
},
{
  nome: "Ursinha Flora",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-153482a6.png?v=1788244832",
  variant: "46984433958996",
  itens: [
    "23cm",
    "marfim",
    "Pé para usar com sapato",
    "Calçola Listrada",
    "Camisa com gola - Rosa bebê",
    "Jardineira - Marrom",
    "Meia com flor - Rosa bebê",
    "Sapato floral",
    "Tiara - Rosa bebê",
    "Bolsa transversal - Dourada",
    "Relógio - Rosa"
  ]
},
{
  nome: "Ursinha Charlotte",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-3d01f313.png?v=1788281794",
  variant: "46984433893460",
  itens: [
    "23cm",
    "marrom",
    "Pé para usar com sapato",
    "castanho",
    "Focinho - Preto",
    "Boca Feliz - Marrom",
    "Calçola de poá - Branca",
    "Casaco sobretudo - Caramelo",
    "Meia com flor - Branca",
    "Coturno - Bege",
    "Boina - Bege",
    "Bolsa de mão - Preta",
    "Óculos de grau"
  ]
},
{
  nome: "Ursinha Lili",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-f654bbc8.png?v=1788283021",
  variant: "46984433926228",
  itens: [
    "23cm",
    "marfim",
    "Pé para usar com sapato",
    "azul",
    "Focinho - Rosa",
    "Boca Feliz - Marfim",
    "Calçola Listrada",
    "Camisa manga curta bufante - Rosa chiclete",
    "Vestido rodado - Rosa chiclete",
    "Meia com flor - Rosa bebê",
    "Sandália - Rosa",
    "Tiara - Rosa bebê",
    "Bolsa de mão - Dourada",
    "Relógio - Rosa"
  ]
},
{
  nome: "Ursinha Ivy",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-c5adfd13.png?v=1788283915",
  variant: "46984433827924",
  itens: [
    "23cm",
    "marrom",
    "Pé para usar com sapato",
    "verde",
    "Focinho - Preto",
    "Boca Feliz - Marrom",
    "Shorts c/ cinto preto - Marfim",
    "Camisa com gola - Verde bebê",
    "Meia com flor - Branca",
    "Tênis - Preto",
    "Boina - Branca",
    "Relógio - Verde"
  ]
},
{
  nome: "Ursinha Mel",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-be5c8156.png?v=1788284331",
  variant: "46984433795156",
  itens: [
    "23cm",
    "bege",
    "Pé para usar com sapato",
    "castanho",
    "Focinho - Caramelo",
    "Boca Feliz - Bege",
    "Calçola de poá - Branca",
    "Camisa manga curta bufante - Amarelo bebê",
    "Macacão floral - Amarelo",
    "Sandália - Amarela",
    "Tiara - Amarelo bebê",
    "Bolsa transversal - Dourada",
    "Óculos de grau"
  ]
},
{
  nome: "Ursinha Amora",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-cf8e124e.png?v=1789019100",
  variant: "46984434384980",
  itens: [
    "23cm",
    "marfim",
    "Pé para usar com sapato",
    "castanho",
    "Focinho - Marrom",
    "Boca Feliz - Marfim",
    "Calçola floral - Vermelha",
    "Camisa com gola - Rosa chiclete",
    "Jardineira - Bordô",
    "Meia com flor - Branca",
    "Botinha - Bordô",
    "Boina - Rosa bebê",
    "Bolsa transversal - Dourada",
    "Óculos de grau",
    "Relógio - Rosa"
  ]
},
{
  nome: "Ursinha Cherry",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-4d1c5e78.png?v=1788284741",
  variant: "46984434122836",
  itens: [
    "23cm",
    "marrom",
    "Pé para usar com sapato",
    "preto",
    "Focinho - Preto",
    "Boca Sério - Marrom",
    "Calçola floral - Vermelha",
    "Shorts c/ cinto rosa - Bordô",
    "Camisa com gola - Rosa chiclete",
    "Meia com cerejinha - Rosa bebê",
    "Sapato floral",
    "Bolsa transversal - Preta",
    "Óculos de grau",
    "Relógio - Rosa"
  ]
},
{
  nome: "Ursinha Sky",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-2d506b7d.png?v=1788285303",
  variant: "46984433500244",
  itens: [
    "23cm",
    "marfim",
    "Pé para usar com sapato",
    "azul",
    "Focinho - Preto",
    "Boca Feliz - Marfim",
    "Calçola de poá - Branca",
    "Vestido rodado - Cinza azulado",
    "Casaco sem gola - Azul bebê",
    "Meia com flor - Azul bebê",
    "Botinha - Marfim",
    "Tiara - Azul bebê"
  ]
},
{
  nome: "Ursinha Valentina",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-2bae0b48.png?v=1788393192",
  variant: "46984433893460",
  itens: [
    "23cm",
    "bege",
    "Pé para usar com sapato",
    "castanho",
    "Focinho - Preto",
    "Calçola Listrada",
    "Shorts c/ cinto preto - Bordô",
    "Camisa manga curta bufante - Bordô",
    "Sandália - Preta",
    "Bolsa de mão - Preta",
    "Óculos de grau"
  ]
},
{
  nome: "Ursinha Scarlett",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-f9176f3c.png?v=1788287396",
  variant: "46984434679892",
  itens: [
    "23cm",
    "marfim",
    "Pé para usar com sapato",
    "azul",
    "Focinho - Marrom",
    "Calçola floral - Vermelha",
    "Shorts c/ cinto preto - Bordô",
    "Macacão floral - Vermelho",
    "Casaco com gola - Marfim",
    "Meia com flor - Branca",
    "Botinha - Bordô",
    "Touca com protetor de orelha - Vermelha",
    "Bolsa crossbody - Preta",
    "Óculos de grau"
  ]
},
{
  nome: "Ursinha Hazel",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-cef9cc58.png?v=1788287743",
  variant: "46984433860692",
  itens: [
    "23cm",
    "marrom",
    "Pé para usar com sapato",
    "verde",
    "Focinho - Preto",
    "Boca Feliz - Marrom",
    "Calçola de poá - Branca",
    "Camisa com gola - Verde bebê",
    "Jardineira - Verde Musgo",
    "Botinha - Verde musgo",
    "Boina - Bege",
    "Relógio - Verde"
  ]
},
{
  nome: "Ursinha Lavínia",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-a3aaf5f0.png?v=1788288565",
  variant: "46984433958996",
  itens: [
    "23cm",
    "bege",
    "Pé para usar com sapato",
    "preto",
    "Focinho - Rosa",
    "Boca Feliz - Bege",
    "Calçola de poá - Branca",
    "Shorts c/ cinto rosa - Marfim",
    "Camisa manga curta bufante - Rosa envelhecido",
    "Meia com flor - Rosa bebê",
    "Sapato floral",
    "Tiara - Lilás",
    "Bolsa transversal - Dourada",
    "Óculos de grau"
  ]
},
{
  nome: "Ursinha Aurora",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-3f59922c.png?v=1788407397",
  variant: "46984433336404",
  itens: [
    "23cm",
    "marfim",
    "Pé para usar com sapato",
    "azul",
    "Focinho - Rosa",
    "Calçola de poá - Branca",
    "Camisa manga curta bufante - Rosa envelhecido",
    "Vestido rodado - Rosa envelhecido",
    "Sandália - Branca",
    "Tiara - Branca"
  ]
},
{
  nome: "Ursinha Chanel",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-b9ca27ac.png?v=1788408045",
  variant: "46984434221140",
  itens: [
    "23cm",
    "marrom",
    "Pé para usar com sapato",
    "castanho",
    "Focinho - Preto",
    "Boca Feliz - Marrom",
    "Calçola de poá - Branca",
    "Shorts c/ cinto preto - Marrom",
    "Camisa manga curta bufante - Branca",
    "Casaco sem gola - Branco",
    "Sandália - Preta",
    "Tiara - Branca",
    "Bolsa crossbody - Preta",
    "Óculos de grau"
  ]
},
{
  nome: "Ursinha Mabel",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-873d564.png?v=1788500494",
  variant: "46984434516052",
  itens: [
    "23cm",
    "bege",
    "Pé para usar com sapato",
    "castanho",
    "Focinho - Marrom",
    "Calçola listrada",
    "Camisa com gola - Rosa envelhecido",
    "Jardineira - Marrom",
    "Casaco com gola - Marfim",
    "Meia com laço - Branca",
    "Botinha - Marfim",
    "Touca com protetor de orelha - Bege",
    "Bolsa transversal - Dourada",
    "Óculos de grau"
  ]
},
{
  nome: "Ursinha Nina",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-31966cdf.png?v=1788501444",
  variant: "46984433631316",
  itens: [
    "23cm",
    "marfim",
    "Pé para usar com sapato",
    "azul",
    "Focinho - Marrom",
    "Boca Feliz - Marfim",
    "Calçola de poá - Branca",
    "Casaco sobretudo - Branco",
    "Meia com flor - Branca",
    "Botinha - Marfim",
    "Boina - Branca",
    "Bolsa transversal - Preta"
  ]
},
{
  nome: "Ursinha Esmeralda",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-5fde8c27.png?v=1788501888",
  variant: "46984433631316",
  itens: [
    "23cm",
    "marrom",
    "Pé para usar com sapato",
    "verde",
    "Focinho - Preto",
    "Boca Feliz - Marrom",
    "Calçola de poá - Branca",
    "Camisa manga curta bufante - Verde bebê",
    "Vestido rodado - Verde bebê",
    "Sandália - Branca",
    "Tiara - Branca",
    "Bolsa de mão - Preta"
  ]
},
{
  nome: "Ursinha Daisy",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-d42a7195.png?v=1788502816",
  variant: "46984434057300",
  itens: [
    "23cm",
    "bege",
    "Pé para usar com sapato",
    "verde",
    "Focinho - Marrom",
    "Boca Sério - Bege",
    "Calçola de poá - Branca",
    "Camisa com gola - Verde bebê",
    "Jardineira - Marfim",
    "Meia com flor - Bege claro",
    "Coturno - Bege",
    "Boina - Bege",
    "Óculos de grau",
    "Relógio - Verde"
  ]
},
{
  nome: "Ursinha Kiara",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-c239ab0a.png?v=1788555340",
  variant: "46984433795156",
  itens: [
    "23cm",
    "marrom",
    "Pé para usar com sapato",
    "azul",
    "Focinho - Preto",
    "Shorts c/ cinto preto - Marfim",
    "Camisa manga curta bufante - Azul marinho",
    "Sandália - Preta",
    "Boina - Azul bebê",
    "Bolsa crossbody - Preta"
  ]
},
{
  nome: "Ursinha Bella",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-16fe76a6.png?v=1788557844",
  variant: "46984433533012",
  itens: [
    "23cm",
    "marfim",
    "Pé para usar com sapato",
    "preto",
    "Focinho - Marrom",
    "Boca Sério - Marfim",
    "Calçola listrada",
    "Camisa manga longa - Rosa chiclete",
    "Meia com laço - Branca",
    "Sandália - Rosa",
    "Boina - Rosa bebê",
    "Bolsa transversal - Dourada"
  ]
},
{
  nome: "Ursinha Rosie",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-a1f384f8.png?v=1788558571",
  variant: "46984433893460",
  itens: [
    "23cm",
    "bege",
    "Pé para usar com sapato",
    "verde",
    "Focinho - Marrom",
    "Boca Feliz - Bege",
    "Calçola floral - Vermelha",
    "Camisa com gola - Rosa chiclete",
    "Macacão floral - Vermelho",
    "Meia com flor - Rosa bebê",
    "Sapato floral",
    "Tiara - Rosa bebê",
    "Bolsa transversal - Dourada",
    "Óculos de grau"
  ]
},
{
  nome: "Ursinha Cacau",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-4742ecdf.png?v=1788630526",
  variant: "46984434155604",
  itens: [
    "23cm",
    "marrom",
    "Pé para usar com sapato",
    "castanho",
    "Focinho - Preto",
    "Calçola de poá - Branca",
    "Jardineira - Marrom",
    "Casaco com gola - Marrom",
    "Meia com laço - Amarela",
    "Botinha - Marrom",
    "Boina - Bege",
    "Bolsa crossbody - Preta"
  ]
},
{
  nome: "Ursinha Honey",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-4557352.png?v=1788630889",
  variant: "46984433434708",
  itens: [
    "23cm",
    "bege",
    "Pé para usar com sapato",
    "castanho",
    "Focinho - Caramelo",
    "Calçola de poá - Branca",
    "Casaco sobretudo - Caramelo",
    "Meia com cerejinha - Amarelo",
    "Sandália - Amarela",
    "Tiara - Amarelo bebê",
    "Bolsa crossbody - Dourada"
  ]
},
{
  nome: "Ursinha Sunny",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-59b2be40.png?v=1788632454",
  variant: "46984434450516",
  itens: [
    "30cm",
    "marfim",
    "Pé para usar com sapato",
    "castanho",
    "Focinho - Caramelo",
    "Camisa manga curta bufante - Branca",
    "Macacão floral - Amarelo",
    "Casaco com gola - Marfim",
    "Meia com flor - Branca",
    "Sandália - Amarela",
    "Tiara - Amarelo bebê",
    "Bolsa transversal - Dourada"
  ]
},
{
  nome: "Ursinha Rosé",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-38d92851.png?v=1789015996",
  variant: "46984434122836",
  itens: [
    "23cm",
    "marrom",
    "Pé para usar com sapato",
    "verde",
    "Focinho - Preto",
    "Boca Feliz - Marrom",
    "Calçola listrada",
    "Shorts c/ cinto rosa - Marfim",
    "Camisa manga curta bufante - Rosa chiclete",
    "Meia com cerejinha - Rosa bebê",
    "Sandália - Rosa",
    "Tiara - Rosa bebê",
    "Bolsa transversal - Dourada",
    "Óculos de grau",
    "Relógio - Rosa"
  ]
},
{
  nome: "Ursinha Amélie",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-e4cfb47b.png?v=1788632661",
  variant: "46984435040340",
  itens: [
    "45cm",
    "marfim",
    "Pé para usar com sapato",
    "castanho",
    "Focinho - Rosa",
    "Calçola floral - Vermelha",
    "Shorts c/ cinto rosa - Marrom",
    "Camisa com gola - Branca",
    "Casaco sem gola - Rosa bebê",
    "Sandália - Rosa",
    "Tiara - Rosa bebê",
    "Bolsa transversal - Dourada"
  ]
},
{
  nome: "Ursinha Sophie",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-41b16443.png?v=1789017434",
  variant: "46984434188372",
  itens: [
    "23cm",
    "bege",
    "Pé para usar com sapato",
    "preto",
    "Focinho - Marrom",
    "Calçola listrada",
    "Camisa manga longa - Rosa chiclete",
    "Casaco com gola - Marfim",
    "Meia com laço - Rosa bebê",
    "Sandália - Branca",
    "Boina - Rosa bebê",
    "Bolsa transversal - Dourada",
    "Óculos de grau"
  ]
},
{
  nome: "Ursinha Celeste",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-c49cacc.png?v=1789018112",
  variant: "46984434516052",
  itens: [
    "23cm",
    "marrom",
    "Pé para usar com sapato",
    "azul",
    "Focinho - Preto",
    "Calçola de poá - Branca",
    "Shorts c/ cinto branco - Marfim",
    "Camisa com gola - Cinza azulado",
    "Casaco sem gola - Azul bebê",
    "Meia com flor - Azul bebê",
    "Botinha - Marfim",
    "Boina - Branca",
    "Bolsa crossbody - Preta",
    "Óculos de grau"
  ]
},
{
  nome: "Ursinha Rubi",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-dba49f9c.png?v=1789017645",
  variant: "46984433958996",
  itens: [
    "23cm",
    "marfim",
    "Pé para usar com sapato",
    "castanho",
    "Focinho - Marrom",
    "Boca Sério - Marfim",
    "Calçola de poá - Branca",
    "Camisa com gola - Branca",
    "Jardineira - Bordô",
    "Meia com cerejinha - Rosa bebê",
    "Sandália - Branca",
    "Tiara - Branca",
    "Bolsa crossbody - Preta",
    "Relógio - Rosa"
  ]
},
{
  nome: "Ursinha Jade",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-5a2c97bb.png?v=1789017784",
  variant: "46984434548820",
  itens: [
    "23cm",
    "bege",
    "Pé para usar com sapato",
    "verde",
    "Calçola de poá - Branca",
    "Shorts c/ cinto preto - Verde musgo",
    "Camisa manga curta bufante - Verde militar",
    "Jardineira - Marfim",
    "Meia com flor - Branca",
    "Botinha - Verde musgo",
    "Tiara - Branca",
    "Bolsa transversal - Preta",
    "Óculos de grau",
    "Relógio - Verde"
  ]
},
{
  nome: "Ursinha Liz",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-27befa04.png?v=1789018956",
  variant: "46984434384980",
  itens: [
    "23cm",
    "marrom",
    "Pé para usar com sapato",
    "azul",
    "Focinho - Preto",
    "Calçola de poá - Branca",
    "Shorts c/ cinto branco - Marfim",
    "Camisa com gola - Rosa bebê",
    "Meia com flor - Branca",
    "Botinha - Marfim",
    "Boina - Rosa bebê",
    "Bolsa transversal - Dourada",
    "Óculos de grau",
    "Relógio - Rosa"
  ]
},
{
  nome: "Ursinha Serena",
  imagem: "https://cdn.shopify.com/s/files/1/0288/2922/0948/files/montagem-be61b48.png?v=1789019506",
  variant: "46984434122836",
  itens: [
    "23cm",
    "marfim",
    "Pé para usar com sapato",
    "azul",
    "Focinho - Preto",
    "Calçola de poá - Branca",
    "Shorts c/ cinto preto - Marfim",
    "Camisa manga curta bufante - Cinza azulado",
    "Meia com flor - Branca",
    "Sandália - Preta",
    "Boina - Branca",
    "Bolsa transversal - Preta",
    "Óculos de grau"
  ]
}
];

  var lista = document.querySelector(".ursinhas-prontas-lista");

  if(!lista){
    return;
  }

  lista.innerHTML = "";

  modelosProntos.forEach(function(modelo){

    var card = document.createElement("div");
    card.className = "ursinha-pronta-card";

    card.innerHTML =
      '<img src="' + modelo.imagem + '" alt="' + modelo.nome + '">' +
      '<h4>' + modelo.nome + '</h4>' +
      '<button type="button" class="ursinha-pronta-escolher">Escolher esta ursinha</button>';

    var botao = card.querySelector(".ursinha-pronta-escolher");

    botao.addEventListener("click", function(){

        sessionStorage.setItem(
  "svs_modelo_pronto_escolhido",
  "1"
);

      var url = new URL(window.location.href);

      url.searchParams.set(
        "monte_itens",
        modelo.itens.join("|")
      );

      url.searchParams.set(
        "variant",
        modelo.variant
      );

      window.location.href = url.toString();

    });

    lista.appendChild(card);

  });

});

/* =========================================================
   MEMÓRIA DA ÚLTIMA PEÇA POR CATEGORIA / TAMANHO
   ========================================================= */

var ultimaPecaPorGrupo = {};
var restaurandoPecaPorTamanho = false;

function grupoDaPeca(c){
  return String(c.dataset.grupo || "").trim().toLowerCase();
}

function tamanhosBloqueadosDaPeca(c){
  return String(c.dataset.tamanhosBloqueados || "")
    .split(",")
    .map(function(x){ return x.trim(); })
    .filter(Boolean);
}

function grupoPodeSerMemorizado(grupo){
  return (
    grupo &&
    grupo !== "tamanho" &&
    grupo !== "base_personalizada" &&
    grupo !== "local_gravacao" &&
    grupo.indexOf("aparencia_") !== 0
  );
}


/* Guarda as peças que já vieram selecionadas,
   inclusive as do modelo pronto */
document.addEventListener("DOMContentLoaded", function(){

  document.querySelectorAll(
    ".monte-ursinha-check:checked"
  ).forEach(function(c){

    var grupo = grupoDaPeca(c);

    if(grupoPodeSerMemorizado(grupo)){
      ultimaPecaPorGrupo[grupo] = c.dataset.item;
    }

  });

});


/* Sempre que o cliente escolhe outra peça,
   ela passa a ser a última escolha daquela categoria */
document.addEventListener("change", function(e){

  var c = e.target;

  if(
    !c.classList.contains("monte-ursinha-check")
  ){
    return;
  }

  var grupo = grupoDaPeca(c);

  if(!grupoPodeSerMemorizado(grupo)){
    return;
  }

  if(c.checked){

    ultimaPecaPorGrupo[grupo] =
      c.dataset.item;

  }else if(
    ultimaPecaPorGrupo[grupo] === c.dataset.item
  ){

    delete ultimaPecaPorGrupo[grupo];

  }

}, true);


/* Depois da troca de tamanho,
   tenta restaurar a última escolha de cada categoria */
document.addEventListener("change", function(e){

  var tamanho = e.target;

  if(
    restaurandoPecaPorTamanho ||
    grupoDaPeca(tamanho) !== "tamanho" ||
    !tamanho.checked
  ){
    return;
  }

  var tamanhoAtual =
    String(tamanho.dataset.item || "").trim();

  setTimeout(function(){

    var restaurou = false;

    Object.keys(ultimaPecaPorGrupo).forEach(function(grupo){

      var nome =
        ultimaPecaPorGrupo[grupo];

      var c = Array.from(
        document.querySelectorAll(".monte-ursinha-check")
      ).find(function(input){

        return (
          grupoDaPeca(input) === grupo &&
          input.dataset.item === nome
        );

      });

      if(!c){
        return;
      }

      var bloqueados =
        tamanhosBloqueadosDaPeca(c);

      /*
       * Continua incompatível:
       * mantém na memória, mas não mostra.
       */
      if(
        bloqueados.indexOf(tamanhoAtual) !== -1
      ){
        return;
      }

      /*
       * Já está selecionada:
       * não precisa fazer nada.
       */
      if(c.checked){
        return;
      }

      c.disabled = false;

      var card =
        c.closest(".monte-ursinha-card");

      if(card){
        card.classList.remove(
          "monte-card-bloqueado-tamanho"
        );
      }

      c.click();

      restaurou = true;

    });


    if(restaurou){

      setTimeout(function(){

        var preview =
          document.getElementById(
            "UrsinhaPreviewPng"
          );

        if(preview){

          var congelado =
            preview.querySelector(
              ".monte-preview-congelado"
            );

          if(congelado){
            congelado.remove();
          }

        }

        /*
         * Faz o sistema original redesenhar
         * preço e camadas da montagem.
         */
        restaurandoPecaPorTamanho = true;

        tamanho.dispatchEvent(
          new Event("change", {
            bubbles: true
          })
        );

        restaurandoPecaPorTamanho = false;

      }, 50);

    }

  }, 200);

}, true);

/* =========================================================
   BLOQUEIO DE TAMANHO NAS PALETAS DE CORES
   ========================================================= */

function monteTamanhosBloqueados(input){
  return String(input.dataset.tamanhosBloqueados || "")
    .split(",")
    .map(function(x){ return x.trim(); })
    .filter(Boolean);
}

function monteTamanhoAtual(){
  var tamanho = document.querySelector(
    '.monte-ursinha-check[data-grupo="tamanho"]:checked'
  );

  return tamanho
    ? String(tamanho.dataset.item || "").trim()
    : "";
}

/* =========================================================
   MAPA FIXO DAS PALETAS DE CORES
   ========================================================= */

function monteMapearPaletas(){

  var grupos = document.querySelectorAll(
    ".monte-grupo:not(.monte-mais-acessorios)"
  );

  grupos.forEach(function(grupo){

    var cards = Array.from(
      grupo.querySelectorAll(".monte-ursinha-card")
    );

    var modelos = {};

    cards.forEach(function(card){

      var input = card.querySelector(
        ".monte-ursinha-check"
      );

      if(!input){
        return;
      }

      /*
       * IMPORTANTE:
       * modelo e cor são lidos do CARD,
       * porque esses dados nunca são sobrescritos
       * quando outra cor da paleta é selecionada.
       */
      var modelo = String(
        card.dataset.modelo || ""
      ).trim();

      var cor = String(
        card.dataset.cor || ""
      ).trim();

      if(!modelo || !cor){
        return;
      }

      /*
       * Guarda uma cópia IMUTÁVEL da identidade
       * original deste produto técnico.
       */
      input.dataset.monteModeloPaleta = modelo;
      input.dataset.monteCorPaletaOriginal = cor;

      input.dataset.monteBloqueiosOriginais =
        String(
          input.dataset.tamanhosBloqueados || ""
        );

      if(!modelos[modelo]){
        modelos[modelo] = [];
      }

      modelos[modelo].push({
        card: card,
        input: input
      });

    });

    Object.keys(modelos).forEach(function(modelo){

      var itens = modelos[modelo];

      if(itens.length <= 1){
        return;
      }

      itens[0].card.dataset.montePaleta = "sim";

      var principal = itens[0];

if(!principal.card.dataset.monteImagemOriginal){
  var imgPrincipal = principal.card.querySelector("img");

  if(imgPrincipal){
    principal.card.dataset.monteImagemOriginal =
      imgPrincipal.src;
  }
}

    });

  });

}

document.addEventListener("DOMContentLoaded", function(){
  setTimeout(monteMapearPaletas, 300);
});

/* =========================================================
   BLOQUEIO DAS CORES INCOMPATÍVEIS NA PALETA
   ========================================================= */

function monteAtualizarBloqueioPaletas(){

  var tamanhoAtual = monteTamanhoAtual();

  if(!tamanhoAtual){
    return;
  }

  document.querySelectorAll(
    '.monte-ursinha-check[data-monte-modelo-paleta]'
  ).forEach(function(input){

    var bloqueados = String(
  input.dataset.monteBloqueiosOriginais || ""
)
  .split(",")
  .map(function(x){
    return x.trim();
  })
  .filter(Boolean);

    var bloqueado =
      bloqueados.indexOf(tamanhoAtual) !== -1;

    input.dataset.monteCorBloqueada =
      bloqueado ? "sim" : "nao";

  });

}

document.addEventListener("DOMContentLoaded", function(){
  setTimeout(monteAtualizarBloqueioPaletas, 400);
});

document.addEventListener("change", function(e){

  var input = e.target;

  if(
    input.classList.contains("monte-ursinha-check") &&
    String(input.dataset.grupo || "").trim() === "tamanho" &&
    input.checked
  ){
    setTimeout(monteAtualizarBloqueioPaletas, 100);
  }

});

/* =========================================================
   IMPEDE ESCOLHER COR BLOQUEADA NA PALETA
   ========================================================= */

document.addEventListener("click", function(e){

  var alvo = e.target.closest(
    '[data-monte-modelo-paleta]'
  );

  if(!alvo){
    return;
  }

  if(alvo.dataset.monteCorBloqueada !== "sim"){
    return;
  }

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  if(typeof mostrarPopup === "function"){
    mostrarPopup("Esta cor está indisponível neste tamanho de urso.");
  }else{
    alert("Esta cor está indisponível neste tamanho de urso.");
  }

}, true);

/* =========================================================
   LEVA O BLOQUEIO DE TAMANHO PARA AS BOLINHAS DA PALETA
   ========================================================= */

document.addEventListener("click", function(e){

  var card = e.target.closest(
    '.monte-ursinha-card[data-tem-paleta="sim"]'
  );

  if(!card){
    return;
  }

  setTimeout(function(){

    var popup = document.querySelector(".monte-popup-cores");

    if(!popup){
      return;
    }

    var inputPrincipal = card.querySelector(
      ".monte-ursinha-check"
    );

    if(!inputPrincipal){
      return;
    }

    var modelo = String(
      inputPrincipal.dataset.modelo || ""
    ).trim();

    var opcoes = Array.from(
      popup.querySelectorAll(".monte-popup-cor")
    );

    var inputsDoModelo = Array.from(
      document.querySelectorAll(
        '.monte-ursinha-check[data-monte-modelo-paleta]'
      )
    ).filter(function(input){

      return String(
        input.dataset.monteModeloPaleta || ""
      ).trim() === modelo;

    });

    opcoes.forEach(function(botao){

      var cor = String(
        botao.getAttribute("aria-label") || ""
      ).trim();

      var inputDaCor = inputsDoModelo.find(function(input){

  return String(
    input.dataset.monteCorPaletaOriginal || ""
  ).trim() === cor;

});

      if(!inputDaCor){
        return;
      }

      botao.dataset.monteCorBloqueada =
        inputDaCor.dataset.monteCorBloqueada || "nao";

    });

  }, 50);

}, true);

/* =========================================================
   IMPEDE CLIQUE NA COR BLOQUEADA DA PALETA
   ========================================================= */

document.addEventListener("click", function(e){

  var botaoCor = e.target.closest(".monte-popup-cor");

  if(!botaoCor){
    return;
  }

  if(botaoCor.dataset.monteCorBloqueada !== "sim"){
    return;
  }

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  document.querySelectorAll(".monte-popup-cores").forEach(function(popup){
  popup.remove();
});

if(typeof mostrarPopup === "function"){
  mostrarPopup(
    "Esta cor está indisponível neste tamanho de urso."
  );
}

}, true);

/* =========================================================
   REMOVE COR SELECIONADA QUANDO O NOVO TAMANHO A BLOQUEAR
   ========================================================= */

document.addEventListener("change", function(e){

  var tamanho = e.target;

  if(
    !tamanho.classList.contains("monte-ursinha-check") ||
    String(tamanho.dataset.grupo || "").trim() !== "tamanho" ||
    !tamanho.checked
  ){
    return;
  }

  var tamanhoAtual = String(
    tamanho.dataset.item || ""
  ).trim();

  setTimeout(function(){

    document.querySelectorAll(
      '.monte-ursinha-card[data-tem-paleta="sim"]'
    ).forEach(function(card){

      var principal = card.querySelector(
        ".monte-ursinha-check"
      );

      if(!principal || !principal.checked){
        return;
      }

      var modeloSelecionado = String(
        principal.dataset.modelo || ""
      ).trim();

      var corSelecionada = String(
        principal.dataset.cor || ""
      ).trim();

      if(!modeloSelecionado || !corSelecionada){
        return;
      }

      var inputOriginal = Array.from(
        document.querySelectorAll(
          '.monte-ursinha-check[data-monte-modelo-paleta]'
        )
      ).find(function(input){

        return (
          String(input.dataset.monteModeloPaleta || "").trim() === modeloSelecionado &&
          String(input.dataset.cor || "").trim() === corSelecionada &&
          input !== principal
        );

      });

      /*
       * Se a cor escolhida for justamente a primeira cor
       * da paleta, o próprio principal é o produto original.
       */
      if(!inputOriginal){

        inputOriginal = principal;

      }

      var bloqueados =
        monteTamanhosBloqueados(inputOriginal);

      if(
        bloqueados.indexOf(tamanhoAtual) === -1
      ){
        return;
      }

      principal.checked = false;
      principal.disabled = false;

      card.classList.remove(
        "monte-card-selecionado",
        "monte-card-bloqueado-tamanho"
      );

      var titulo = card.querySelector("span");
var imagem = card.querySelector("img");

if(imagem && card.dataset.monteImagemOriginal){
  imagem.src = card.dataset.monteImagemOriginal;
}

if(titulo){
  titulo.innerHTML =
    '<div class="monte-modelo">' +
    modeloSelecionado +
    '</div>' +
    '<div class="monte-cor">Selecione uma cor</div>';
}

      principal.dispatchEvent(
        new Event("change", {
          bubbles: true
        })
      );

    });

  }, 250);

}, true);

/* =========================================================
   BLOQUEIA / DESBLOQUEIA ITENS DA SACOLA POR TAMANHO
   ========================================================= */

function monteAtualizarBloqueioItensSacola(){

  var tamanhoAtual = monteTamanhoAtual();

  if(!tamanhoAtual){
    return;
  }

  var extras = JSON.parse(
    localStorage.getItem("monte_itens_extras") || "[]"
  );

  extras.forEach(function(extra, indice){

    var nomeExtra = String(
      extra.nome || ""
    ).trim();

    var botaoOriginal = Array.from(
      document.querySelectorAll(".monte-extra-adicionar")
    ).find(function(botao){

      return String(
        botao.dataset.itemExtra || ""
      ).trim() === nomeExtra;

    });

    var bloqueado = false;

    if(botaoOriginal){

      var cardOriginal =
        botaoOriginal.closest(".monte-ursinha-card");

      var inputOriginal = cardOriginal
        ? cardOriginal.querySelector(".monte-ursinha-check")
        : null;

      if(inputOriginal){

        var bloqueados = String(
          inputOriginal.dataset.monteBloqueiosOriginais ||
          inputOriginal.dataset.tamanhosBloqueados ||
          ""
        )
          .split(",")
          .map(function(x){
            return x.trim();
          })
          .filter(Boolean);

        bloqueado =
          bloqueados.indexOf(tamanhoAtual) !== -1;

      }

    }

    extra.bloqueadoTamanho = bloqueado;

    var linha = document.querySelector(
      '#ListaSacolaMonte [data-indice-extra="' + indice + '"]'
    );

    if(!linha){
      return;
    }

    var aviso = linha.querySelector(
      ".monte-extra-aviso-tamanho"
    );

    if(bloqueado){

      linha.classList.add(
        "monte-extra-bloqueado-tamanho"
      );

      if(!aviso){

        aviso = document.createElement("div");
        aviso.className =
          "monte-extra-aviso-tamanho";

        linha.appendChild(aviso);

      }

      aviso.textContent =
        "Indisponível em " + tamanhoAtual;

    }else{

      linha.classList.remove(
        "monte-extra-bloqueado-tamanho"
      );

      if(aviso){
        aviso.remove();
      }

    }

  });

  localStorage.setItem(
    "monte_itens_extras",
    JSON.stringify(extras)
  );

  monteAtualizarTotalDisponivelSacola();

}

document.addEventListener("DOMContentLoaded", function(){

  setTimeout(
    monteAtualizarBloqueioItensSacola,
    500
  );

});

document.addEventListener("change", function(e){

  var tamanho = e.target;

  if(
    tamanho.classList.contains("monte-ursinha-check") &&
    String(tamanho.dataset.grupo || "").trim() === "tamanho" &&
    tamanho.checked
  ){

    setTimeout(
      monteAtualizarBloqueioItensSacola,
      350
    );

  }

});

var listaSacolaBloqueio =
  document.getElementById("ListaSacolaMonte");

if(listaSacolaBloqueio){

  new MutationObserver(function(){

    setTimeout(
      monteAtualizarBloqueioItensSacola,
      50
    );

  }).observe(listaSacolaBloqueio, {
    childList: true
  });

}

/* =========================================================
   EXTRAS DISPONÍVEIS PARA COMPRA
   ========================================================= */

window.montePegarExtrasDisponiveis = function(){

  var extras = JSON.parse(
    localStorage.getItem("monte_itens_extras") || "[]"
  );

  return extras.filter(function(item){

    return (
      Number(item.quantidade || 0) > 0 &&
      item.bloqueadoTamanho !== true
    );

  });

};

/* =========================================================
   TOTAL DA SACOLA IGNORANDO ITENS BLOQUEADOS
   ========================================================= */

function monteAtualizarTotalDisponivelSacola(){

  var total = 0;

  document.querySelectorAll(
    "#ListaSacolaMonte .monte-item-extra"
  ).forEach(function(linha){

    if(
      linha.classList.contains(
        "monte-extra-bloqueado-tamanho"
      )
    ){
      return;
    }

    var preco = linha.querySelector(
      ".monte-item-extra-preco"
    );

    if(!preco){
      return;
    }

    var valor = String(preco.textContent || "")
      .replace(/[^\d,]/g, "")
      .replace(",", ".");

    total += Number(valor || 0);

  });

  document.querySelectorAll(
    "#TotalExtrasMonte strong"
  ).forEach(function(totalSacola){

    totalSacola.textContent =
      total.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });

  });

}

/* =========================================================
   MANTÉM O TOTAL DA SACOLA CORRETO
   ========================================================= */

document.addEventListener("DOMContentLoaded", function(){

  var totalSacola = document.querySelector(
    "#TotalExtrasMonte strong"
  );

  if(!totalSacola){
    return;
  }

  var corrigindoTotalSacola = false;

  var observadorTotalSacola =
    new MutationObserver(function(){

      if(corrigindoTotalSacola){
        return;
      }

      corrigindoTotalSacola = true;

      setTimeout(function(){

        monteAtualizarTotalDisponivelSacola();

        corrigindoTotalSacola = false;

      }, 20);

    });

  observadorTotalSacola.observe(
    totalSacola,
    {
      childList: true,
      characterData: true,
      subtree: true
    }
  );

});

function codigoCurtoItemMonte(texto){

  texto = String(texto || "").trim();

  var hash = 2166136261;

  for(var i = 0; i < texto.length; i++){
    hash ^= texto.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }

  return (hash >>> 0).toString(36);
}

function gerarCodigoCurtoMontagem(itens){

  return itens
    .map(function(item){
      return codigoCurtoItemMonte(item);
    })
    .join(".");
}

(function(){

  var params = new URLSearchParams(window.location.search);
  var codigoMontagem = params.get("m");

  if(!codigoMontagem || params.get("monte_itens")){
    return;
  }

  var mapaItens = {};

  function adicionarAoMapa(nome){
    nome = String(nome || "").trim();
    if(!nome) return;

    mapaItens[codigoCurtoItemMonte(nome)] = nome;
  }

  document.querySelectorAll(
    ".monte-ursinha-check"
  ).forEach(function(input){
    adicionarAoMapa(input.dataset.item);
  });

  [
    "preto",
    "azul",
    "verde",
    "castanho",

    "Focinho - Preto",
    "Focinho - Marrom",
    "Focinho - Rosa",
    "Focinho - Caramelo",

    "Boca Feliz - Marfim",
    "Boca Feliz - Bege",
    "Boca Feliz - Marrom",
    "Boca Sério - Marfim",
    "Boca Sério - Bege",
    "Boca Sério - Marrom",

    "Pé para usar com sapato",
    "Pé sem sapato",

    "Sem gravação",
    "Gravação na barriga",
    "Gravação no braço",
    "Gravação no pé"
  ].forEach(adicionarAoMapa);

  var itensRestaurados = codigoMontagem
    .split(".")
    .map(function(codigo){
      return mapaItens[codigo] || "";
    })
    .filter(Boolean);

  if(!itensRestaurados.length){
    return;
  }

  params.delete("m");

  params.set(
    "monte_itens",
    itensRestaurados.join("|")
  );

  var novaUrl =
    window.location.pathname +
    "?" +
    params.toString();

  window.location.replace(novaUrl);

})();

/* BOTÃO COMPARTILHAR URSINHA */
document.addEventListener("DOMContentLoaded", function(){

  var zero = document.getElementById("ComecarUrsinhaDoZero");
  if(!zero) return;

  var botao = document.createElement("button");
  botao.type = "button";
  botao.id = "CompartilharUrsinha";
  botao.className = "monte-compartilhar-ursinha";

  botao.innerHTML =
  '<span>Compartilhar</span>';

  var preview = document.getElementById("UrsinhaPreviewPng");

if(preview){
  preview.insertAdjacentElement("afterend", botao);

  if(preview.parentElement){
    preview.parentElement.classList.add("monte-area-compartilhar");
  }
}

function atualizarVisibilidadeCompartilhar(){

  var corSelecionada = document.querySelector(
    '.monte-ursinha-check[data-grupo="base_personalizada"]:checked'
  );

  botao.style.display =
    corSelecionada ? "flex" : "none";
}

atualizarVisibilidadeCompartilhar();

document.addEventListener("change", function(e){

  if(
    e.target.classList.contains("monte-ursinha-check")
  ){
    setTimeout(
      atualizarVisibilidadeCompartilhar,
      50
    );
  }

});

var observarPreviewCompartilhar =
  new MutationObserver(function(){
    atualizarVisibilidadeCompartilhar();
  });

observarPreviewCompartilhar.observe(preview, {
  attributes: true,
  attributeFilter: ["style", "class"]
});

async function gerarImagemCompartilhamentoUrsinha(){

  var preview =
    document.getElementById("UrsinhaPreviewPng");

  if(!preview){
    return null;
  }

  var temUrsinhaMontada =
    !!preview.querySelector(".ursinha-layer");

  /* =========================================
     FOTO NORMAL DA GALERIA
     Compartilha exatamente a foto que está
     aparecendo no preview
  ========================================= */

  if(!temUrsinhaMontada){

    var fotoAtual =
      preview.querySelector("img");

    if(!fotoAtual || !fotoAtual.src){
      return null;
    }

    try{

      var resposta =
        await fetch(fotoAtual.src);

      if(!resposta.ok){
        return null;
      }

      return await resposta.blob();

    }catch(erro){

      console.error(
        "Erro ao preparar foto atual:",
        erro
      );

      return null;
    }

  }

  /* =========================================
     URSINHA MONTADA
  ========================================= */

  var canvas = document.createElement("canvas");
  var size = 1000;

  canvas.width = size;
  canvas.height = size;

  var ctx = canvas.getContext("2d");

  var layers = Array.from(
    preview.querySelectorAll(".ursinha-layer")
  ).filter(function(img){

    return (
      img.style.display !== "none" &&
      !img.closest(".monte-preview-congelado")
    );

  });

  for(var i = 0; i < layers.length; i++){

    await new Promise(function(resolve){

      var imgOriginal = layers[i];
      var temp = new Image();

      temp.crossOrigin = "anonymous";

      temp.onload = function(){

        var ratio = Math.min(
          size / temp.width,
          size / temp.height
        );

        var largura = temp.width * ratio;
        var altura = temp.height * ratio;

        var x = (size - largura) / 2;
        var y = (size - altura) / 2;

        ctx.drawImage(
          temp,
          x,
          y,
          largura,
          altura
        );

        resolve();
      };

      temp.onerror = resolve;

      temp.src = imgOriginal.src;

    });

  }

  return new Promise(function(resolve){

    canvas.toBlob(function(blob){
      resolve(blob);
    }, "image/png");

  });

}

botao.addEventListener("click", async function(e){

  e.preventDefault();
  e.stopPropagation();

  var itens = Array.from(
    document.querySelectorAll(".monte-ursinha-check:checked")
  )
  .map(function(c){
    return String(c.dataset.item || "").trim();
  })
  .filter(Boolean);

  itens = Array.from(new Set(itens));

  var pe = document.querySelector(
    '.monte-ursinha-check[data-grupo="aparencia_pe"]:checked'
  ) || document.querySelector(
    '.monte-ursinha-check[data-grupo="aparencia_pe"]'
  );

  if(pe){
    var itemPe = String(pe.dataset.item || "").trim();

    if(itemPe && itens.indexOf(itemPe) === -1){
      itens.splice(2, 0, itemPe);
    }
  }

  var url = new URL(
    window.location.origin + window.location.pathname
  );

  var variante = new URLSearchParams(
    window.location.search
  ).get("variant");

  if(variante){
    url.searchParams.set("variant", variante);
  }

  url.searchParams.set(
  "m",
  gerarCodigoCurtoMontagem(itens)
);

var link = url.toString();

var previewAtual =
  document.getElementById("UrsinhaPreviewPng");

var temUrsinhaMontadaAtual =
  previewAtual &&
  !!previewAtual.querySelector(".ursinha-layer");

/* Se estiver mostrando uma foto da galeria,
   compartilha somente a página normal do produto */
if(!temUrsinhaMontadaAtual){

  link =
    window.location.origin +
    window.location.pathname;

}

  var ehCelular =
  /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

if(!ehCelular){
  copiarLinkUrsinha(link);
  return;
}

  var arquivoImagem = null;

try{

  var blobImagem =
    await gerarImagemCompartilhamentoUrsinha();

  if(blobImagem){

    arquivoImagem = new File(
      [blobImagem],
      "minha-ursinha.png",
      {type: "image/png"}
    );

  }

}catch(err){

  console.error(
    "Erro ao preparar imagem:",
    err
  );

}

var previewAtual =
  document.getElementById("UrsinhaPreviewPng");

var temUrsinhaMontadaAtual =
  previewAtual &&
  !!previewAtual.querySelector(".ursinha-layer");

  if(!temUrsinhaMontadaAtual){

  link =
    window.location.origin +
    window.location.pathname;

}

var dadosCompartilhar = {
  title: "Monte sua Ursinha ✨",
  text:
    (
      temUrsinhaMontadaAtual
        ?
        "🧸✨ *Olha a ursinha que eu montei!* 🥰\n\n" +
        "Escolhi cada detalhe, das roupinhas aos acessórios. 💕\n\n" +
        "E o mais legal, essa montagem pode virar uma ursinha de verdade! 😍\n\n" +
        "A *Sunshine View Store* produz o modelo com as escolhas feitas na montagem.\n\n" +
        "💖 *Veja a minha e crie a sua também:*\n\n"

        :

        "🧸✨ *Olha que ideia linda que eu encontrei!*\n\n" +
        "Na *Sunshine View Store* você pode montar sua própria ursinha, escolhendo o modelo, roupinhas e acessórios do seu jeito. 💕\n\n" +
        "Dá para personalizar cada detalhe e criar uma ursinha única! 🥰\n\n" +
        "💖 *Conheça e monte a sua:*\n\n"
    ) +
    link
};

if(
  arquivoImagem &&
  navigator.canShare &&
  navigator.canShare({
    files: [arquivoImagem]
  })
){
  dadosCompartilhar.files = [arquivoImagem];
}

if(navigator.share){

  navigator.share(
    dadosCompartilhar
  ).catch(function(){});

}else{

  copiarLinkUrsinha(link);

}

});

function copiarLinkUrsinha(link){

  if(navigator.clipboard && navigator.clipboard.writeText){

    navigator.clipboard.writeText(link).then(function(){

      if(typeof mostrarPopup === "function"){
        mostrarPopup("Link da sua ursinha copiado! 🧸✨");
      }else{
        alert("Link da sua ursinha copiado! 🧸✨");
      }

    });

  }else{

    window.prompt(
      "Copie o link da sua ursinha:",
      link
    );

  }
}

});

window.gerarLinkAtualDaUrsinha = function(){

  var itens = Array.from(
    document.querySelectorAll(".monte-ursinha-check:checked")
  )
  .map(function(c){
    return String(c.dataset.item || "").trim();
  })
  .filter(Boolean);

  itens = Array.from(new Set(itens));

  var pe = document.querySelector(
    '.monte-ursinha-check[data-grupo="aparencia_pe"]:checked'
  ) || document.querySelector(
    '.monte-ursinha-check[data-grupo="aparencia_pe"]'
  );

  if(pe){
    var itemPe = String(pe.dataset.item || "").trim();

    if(itemPe && itens.indexOf(itemPe) === -1){
      itens.splice(2, 0, itemPe);
    }
  }

  var url = new URL(
    window.location.origin + window.location.pathname
  );

  var variante = new URLSearchParams(
    window.location.search
  ).get("variant");

  if(variante){
    url.searchParams.set("variant", variante);
  }

  url.searchParams.set(
    "m",
    gerarCodigoCurtoMontagem(itens)
  );

  return url.toString();
};

window.compartilharPersonalizacaoUrsinha = async function(texto){

var link = window.gerarLinkAtualDaUrsinha
  ? window.gerarLinkAtualDaUrsinha()
  : window.location.href;

var mensagem = texto + "\n\nImagem da ursinha:\n" + link;

window.location.href =
  "https://wa.me/5547984747030?text=" +
  encodeURIComponent(mensagem);    

};

(function instalarDestaqueModeloPe(){

  var tentativas = 0;

  function instalar(){

    tentativas++;

    if(typeof window.mostrarPopup !== "function"){

      if(tentativas < 50){
        setTimeout(instalar, 100);
      }

      return;
    }

    if(window.__destaqueModeloPeInstalado){
      return;
    }

    window.__destaqueModeloPeInstalado = true;

    var mostrarPopupOriginal = window.mostrarPopup;

    window.mostrarPopup = function(mensagem){

      mostrarPopupOriginal.apply(this, arguments);

      var texto = String(mensagem || "").toLowerCase();

      if(texto.indexOf("modelo do pé") === -1){
        return;
      }

      setTimeout(function(){

        var alvoPe = document.getElementById("ModeloPeResumo");

        if(!alvoPe){
          return;
        }

        alvoPe.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });

        setTimeout(function(){

          alvoPe.classList.remove("monte-destaque-pe");

          void alvoPe.offsetWidth;

          alvoPe.classList.add("monte-destaque-pe");

          setTimeout(function(){
            alvoPe.classList.remove("monte-destaque-pe");
          }, 3000);

        }, 650);

      }, 3200);

    };

  }

  instalar();

})();

/* =========================================
   AVISO DO BOTÃO COMPARTILHAR
========================================= */

document.addEventListener("DOMContentLoaded", function () {

  var botao = document.getElementById("CompartilharUrsinha");

  if (!botao) {
    return;
  }

  var area =
  botao.closest(".monte-area-compartilhar");

if (!area) {
  return;
}

  if (document.getElementById("AvisoCompartilharUrsinha")) {
    return;
  }

  var aviso = document.createElement("span");

  aviso.id = "AvisoCompartilharUrsinha";
  aviso.className = "monte-sacola-aviso monte-compartilhar-aviso";

  aviso.innerHTML =
    '<span id="FecharAvisoCompartilharUrsinha" ' +
    'class="monte-sacola-aviso-fechar" ' +
    'role="button" aria-label="Fechar aviso">×</span>' +

    '<strong>Compartilhe sua ursinha com alguém! 🧸✨</strong>';

  area.appendChild(aviso);


 function posicionarAvisoCompartilhar() {

  var rectBotao =
    botao.getBoundingClientRect();

  var rectArea =
    area.getBoundingClientRect();

  var larguraAviso =
    window.innerWidth <= 767 ? 150 : 155;

  var centroBotao =
    (rectBotao.left - rectArea.left) +
    (rectBotao.width / 2);

  var esquerda =
    centroBotao -
    (larguraAviso / 2) -
    25;

  aviso.style.left =
    esquerda + "px";

  var alturaAviso =
    aviso.offsetHeight || 100;

  aviso.style.top =
    (
      rectBotao.top -
      rectArea.top -
      alturaAviso -
      14
    ) + "px";

  var seta =
    centroBotao - esquerda;

  aviso.style.setProperty(
    "--seta-compartilhar",
    seta + "px"
  );
}


  var timerFechar = null;

  function mostrarAvisoCompartilhar() {

    posicionarAvisoCompartilhar();

    aviso.classList.add("ativo");

    sessionStorage.setItem(
  "svs_primeiro_aviso_compartilhar",
  "1"
);

    clearTimeout(timerFechar);

    timerFechar = setTimeout(function () {

      aviso.classList.remove("ativo");

    }, 10000);

  }


  var fechar =
    document.getElementById(
      "FecharAvisoCompartilharUrsinha"
    );

  if (fechar) {

    fechar.addEventListener(
      "click",
      function (event) {

        event.preventDefault();
        event.stopPropagation();

        aviso.classList.remove("ativo");

        clearTimeout(timerFechar);

      }
    );

  }


  /* =========================================
     PRIMEIRO AVISO
  ========================================= */

  var primeiroAvisoProgramado = false;
  var primeiroAvisoMostrado = false;
  var segundoAvisoLiberado = false;
  var segundoAvisoMostrado = false;


  function verificarPrimeiroAviso() {

    if (
  sessionStorage.getItem(
    "svs_primeiro_aviso_compartilhar"
  ) === "1"
) {
  return;
}

    if (
      primeiroAvisoProgramado ||
      primeiroAvisoMostrado
    ) {
      return;
    }

    var grupos = [
      "calcolas",
      "shorts",
      "camisas",
      "roupas",
      "casacos",
      "meias",
      "sapatos",
      "acessorios",
      "cabeca",
      "bolsa",
      "outros"
    ];

    var quantidade = 0;

    document
      .querySelectorAll(
        ".monte-ursinha-check:checked"
      )
      .forEach(function (check) {

        var grupo = String(
          check.dataset.grupo || ""
        )
          .trim()
          .toLowerCase();

        if (
          grupos.indexOf(grupo) !== -1
        ) {
          quantidade++;
        }

      });


    if (quantidade < 4) {
  return;
}

/* ao escolher o 4º item,
   fecha imediatamente o aviso da sacola */

var avisoSacola =
  document.getElementById("AvisoSacolaMonte");

if (avisoSacola) {
  avisoSacola.classList.remove("ativo");
}

primeiroAvisoProgramado = true;

  }


  document.addEventListener(
    "change",
    function (event) {

      if (
        event.target &&
        event.target.classList.contains(
          "monte-ursinha-check"
        )
      ) {
        verificarPrimeiroAviso();
      }

    }
  );


/* =========================================
   MOSTRA O PRIMEIRO AVISO SOMENTE
   DEPOIS QUE A PÁGINA SUBIR
========================================= */

var ultimoScrollCompartilhar = window.scrollY;
var timerPrimeiroAvisoCompartilhar = null;

window.addEventListener(
  "scroll",
  function () {

    var scrollAtual = window.scrollY;

    var subindo =
      scrollAtual < ultimoScrollCompartilhar;

    ultimoScrollCompartilhar = scrollAtual;

    if (
      !primeiroAvisoProgramado ||
      primeiroAvisoMostrado ||
      !subindo
    ) {
      return;
    }

    var rect =
      botao.getBoundingClientRect();

    var botaoVisivel =
      rect.top < window.innerHeight &&
      rect.bottom > 0;

    if (!botaoVisivel) {
      return;
    }

    primeiroAvisoMostrado = true;

    clearTimeout(
      timerPrimeiroAvisoCompartilhar
    );

    timerPrimeiroAvisoCompartilhar =
      setTimeout(function () {

        mostrarAvisoCompartilhar();

        /* depois do primeiro aviso,
           começa a contar 5 minutos */
        setTimeout(function () {

          segundoAvisoLiberado = true;

        }, 300000);

      }, 3250);

  },
  { passive: true }
);

  /* =========================================
     SEGUNDO AVISO
     depois de 5 minutos + subir a página
  ========================================= */

window.addEventListener(
  "scroll",
  function () {

    if (
  aviso.classList.contains("ativo")
) {
  posicionarAvisoCompartilhar();
}

    if (
      !segundoAvisoLiberado ||
      segundoAvisoMostrado
    ) {
      return;
    }

    var quantidadeAtual = 0;

document
  .querySelectorAll(
    ".monte-ursinha-check:checked"
  )
  .forEach(function (check) {

    var grupo = String(
      check.dataset.grupo || ""
    )
      .trim()
      .toLowerCase();

    if (
      [
        "calcolas",
        "shorts",
        "camisas",
        "roupas",
        "casacos",
        "meias",
        "sapatos",
        "acessorios",
        "cabeca",
        "bolsa",
        "outros"
      ].indexOf(grupo) !== -1
    ) {
      quantidadeAtual++;
    }

  });

if (quantidadeAtual < 4) {
  return;
}

    var rect =
      botao.getBoundingClientRect();

    var botaoVisivel =
      rect.top < window.innerHeight &&
      rect.bottom > 0;

    if (!botaoVisivel) {
      return;
    }

    segundoAvisoMostrado = true;

    mostrarAvisoCompartilhar();

  },
  { passive: true }
);


  window.addEventListener(
    "resize",
    function () {

      if (
        aviso.classList.contains("ativo")
      ) {
        posicionarAvisoCompartilhar();
      }

    }
  );

  var veioDeModeloPronto =
  sessionStorage.getItem(
    "svs_modelo_pronto_escolhido"
  ) === "1";

if (veioDeModeloPronto) {
  sessionStorage.removeItem(
    "svs_modelo_pronto_escolhido"
  );
}

var avisoJaApareceu =
  sessionStorage.getItem(
    "svs_primeiro_aviso_compartilhar"
  ) === "1";

if (
  veioDeModeloPronto &&
  !avisoJaApareceu
) {

  setTimeout(function () {

    verificarPrimeiroAviso();

  }, 500);

}

});

/* =========================================================
   TAMANHO OBRIGATÓRIO
   BLOQUEIO ANTES DO SISTEMA DO CARRINHO / YAMPI
========================================================= */

(function(){

  function temTamanhoSelecionado(){

    return !!document.querySelector(
      '.monte-ursinha-check[data-grupo="tamanho"]:checked'
    );

  }

  function avisarTamanhoObrigatorio(){

    if(typeof window.mostrarPopup === "function"){

      window.mostrarPopup(
        "Selecione o tamanho da ursinha antes de continuar."
      );

    }else{

      alert(
        "Selecione o tamanho da ursinha antes de continuar."
      );

    }

  }

  window.addEventListener(
    "click",
    function(e){

      var alvo = e.target;

      if(!alvo || !alvo.closest){
        return;
      }

      var botao = alvo.closest(
        'button[name="add"], ' +
        '.product-form__cart-submit, ' +
        '#AddToCart, ' +
        '#ComprarAgoraYampi'
      );

      if(!botao){
        return;
      }

      if(temTamanhoSelecionado()){
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      avisarTamanhoObrigatorio();

    },
    true
  );

})();

/* =========================================================
   GARANTE IMAGEM DA URSINHA MESMO SEM ROUPAS
========================================================= */

(function(){

  function sincronizarItensPersonalizados(){

    var inputItens =
      document.getElementById("ItensPersonalizados");

    if(!inputItens){
      return;
    }

    var itens = [];

    document.querySelectorAll(
      ".monte-ursinha-check:checked"
    ).forEach(function(check){

      var item = String(
        check.dataset.item || ""
      ).trim();

      if(!item){
        return;
      }

      if(itens.indexOf(item) === -1){
        itens.push(item);
      }

    });

    inputItens.value = itens.join(" | ");

  }


  function instalar(){

    if(
      typeof window.prepararImagemPersonalizadaAntesCarrinho !==
      "function"
    ){

      setTimeout(instalar, 100);
      return;

    }

    if(window.__imagemSemRoupaCorrigida){
      return;
    }

    window.__imagemSemRoupaCorrigida = true;

    var prepararOriginal =
      window.prepararImagemPersonalizadaAntesCarrinho;

    window.prepararImagemPersonalizadaAntesCarrinho =
      async function(){

        sincronizarItensPersonalizados();

        return prepararOriginal.apply(
          this,
          arguments
        );

      };

  }

  instalar();

})();

/* =========================================================
   CORRIGE VARIANTE/PREÇO APÓS RESTAURAR MONTAGEM
========================================================= */

document.addEventListener("DOMContentLoaded", function(){

  setTimeout(function(){

    if(
      typeof window.atualizarMontagemMonte === "function"
    ){
      window.atualizarMontagemMonte();
    }

  }, 500);

});